/* eslint-disable @typescript-eslint/no-shadow */
import { country } from '@models/Country';
import { adminUser } from '@models/User';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const companyStatus = t.union([
  t.literal('ドラフト'),
  t.literal('未対応'),
  t.literal('顧客評価作成待ち'),
  t.literal('会員番号入力待ち'),
  t.literal('手続き完了待ち'),
  t.literal('D2D会員開設申請'),
  t.literal('手続き完了'),
  t.literal('FC未承認'),
]);

export const allCompanyStatus = companyStatus.types.map((l) => l.value);

export type CompanyStatus = t.TypeOf<typeof companyStatus>;

export const companyCustomerServiceGrade = t.type({
  grade: t.number,
  next_grade: t.number,
  next_grade_update_date: h.omittable(t.string),
});

export type CompanyCustomerServiceGrade = t.TypeOf<typeof companyCustomerServiceGrade>;

export const companyCustomerServiceGrades = t.type({
  D2D: companyCustomerServiceGrade,
  'D2DSHENZHEN+': companyCustomerServiceGrade,
  海上速達便: companyCustomerServiceGrade,
  D2DSHENZHEN: companyCustomerServiceGrade,
  D2DQINGDAO: companyCustomerServiceGrade,
});

export type CompanyCustomerServiceGrades = t.TypeOf<typeof companyCustomerServiceGrades>;

export const company = t.type({
  id: t.number,
  company_name: t.string,
  english_name: t.string,
  corporate_number: t.string,
  zip_code: t.string,
  address1: t.string,
  address2: t.string,
  country,
  phone: t.string,
  fax: t.string,
  start_date: h.omittable(t.string),
  representer_last_name: t.string,
  representer_first_name: t.string,
  legal_capital: h.omittable(t.number),
  industry: t.string,
  employee_count: h.omittable(t.number),
  transaction_condition: t.boolean,
  transaction_condition_detail: t.string,
  tos_agreed: t.boolean,
  customer_grade: h.omittable(t.number),
  customer_next_grade: h.omittable(t.number),
  customer_next_grade_update_date: h.omittable(t.string),
  status: companyStatus,
  contact_id: h.omittable(t.number),
  role: h.omittable(t.string),
  member_no: t.string,
  first_food_application_status: t.string,
  first_food_application_d2d_no: h.omittable(t.string),
  first_food_application_etd: h.omittable(t.string),
});

export type Company = t.TypeOf<typeof company>;

export const companyDetails = t.type({
  ...company.props,
  customer_service_grades: companyCustomerServiceGrades,
  salesperson_id: h.omittable(t.number),
  salesperson_last_name: h.omittable(t.string),
  salesperson_name: h.omittable(t.string),
  created_at: t.string,
  updated_at: t.string,
  user: adminUser,
});

export type CompanyDetails = t.TypeOf<typeof companyDetails>;

export const patchCompanyBody = t.partial({
  ...company.props,
  route_plans: t.array(t.number),
});

export type PatchCompany = t.TypeOf<typeof patchCompanyBody>;

export const companyLevel = t.union([
  t.literal('A'),
  t.literal('B'),
  t.literal('C'),
  t.literal('S'),
  t.literal('X'),
]);

export const allCompanyLevel = companyLevel.types.map((l) => l.value);

export type NewCompanyStatus = t.TypeOf<typeof companyStatus>;

export const companyRole = t.union([
  t.literal('shipper'),
  t.literal('shipper_agent'),
  t.literal('consignee'),
  t.literal('consignee_agent'),
]);

export const allCompanyRole = companyRole.types.map((l) => l.value);

export type CompanyRole = t.TypeOf<typeof companyRole>;

export const rolesCanAddShipper = [allCompanyRole[1], allCompanyRole[2], allCompanyRole[3]];
export const rolesCanAddConsignee = [allCompanyRole[0], allCompanyRole[1], allCompanyRole[3]];

export const companyItem = t.type({
  id: t.number,
  created_at: t.string,
  company_name: t.string,
  english_name: h.omittable(t.string),
  status: companyStatus,
  updated_at: t.string,
  approval_no: t.string,
  salesperson_id: h.omittable(t.number),
  salesperson_name: h.omittable(t.string),
  salesperson_last_name: h.omittable(t.string),
  member_no: h.omittable(t.string),
  corporate_number: t.string,
  importer_code: t.string,
  real_time_account: t.string,
  deferred_payment_account: t.string,
  first_food_application_status: t.string,
  first_food_application_d2d_no: h.omittable(t.string),
  first_food_application_etd: h.omittable(t.string),
});

export type CompanyItem = t.TypeOf<typeof companyItem>;

export const companyMemberNo = t.type({
  member_no: t.string,
  approval_no: t.string,
});

export type CompanyMemberNo = t.TypeOf<typeof companyMemberNo>;

export const companyCreateStaff = t.type({
  last_name: t.string,
  first_name: t.string,
  email: t.string,
});

export type CompanyCreateStaff = t.TypeOf<typeof companyCreateStaff>;

export const dashboardCompanyQuery = t.partial({
  page: h.number().cast(),
  page_size: h.number().cast(),
  approval_no: h.string(),
  company_name: h.string(),
  created_at_before: h.string(),
  created_at_after: h.string(),
  ordering: h.array(h.string()),
  status: companyStatus,
  salesperson_id: h.number().cast(),
  email: h.string(),
  fullname: h.string(),
  has_member_salesperson: h.boolean(),
});

export type DashboardCompanyQuery = t.TypeOf<typeof dashboardCompanyQuery>;

export const ownerCompanySearchForm = t.partial({
  company_name: t.string,
  member_no: t.string,
  page: h.number().cast(),
});

export type OwnerCompanySearchForm = t.TypeOf<typeof ownerCompanySearchForm>;
